import { Link } from "react-router-dom";
import { ContentCard } from "cerulean";
import { useLocalization } from "@fluent/react";
import { useDashboardLayoutRedesignEnabled } from "byzantine";
import styles from "./SubscriptionCard.module.scss";
import SubscriptionsPreviewCard from "../SubscriptionsPreviewCard/SubscriptionsPreviewCard";

const SubscriptionCard = () => {
  const { l10n } = useLocalization();
  const isDashboardLayoutRedesignEnabled = useDashboardLayoutRedesignEnabled();

  const title = l10n.getString(
    "subscription-card-title",
    null,
    "Card subscriptions"
  );
  const description = l10n.getString(
    "subscription-card-description",
    null,
    "View recurring transactions"
  );

  if (isDashboardLayoutRedesignEnabled) {
    return <SubscriptionsPreviewCard />;
  }

  return (
    <Link to="/cards/subscriptions">
      <ContentCard kind="elevated">
        <div className={styles.container}>
          <div className={styles.icon}>
            <span className="narmi-icon-refresh-cw" />
          </div>
          <div>
            <span className="fontColor--theme--primary fontSize--m fontWeight--bold margin--bottom--xxs">
              {title}
            </span>
            <p className="fontColor--secondary fontSize--s">{description}</p>
          </div>
        </div>
      </ContentCard>
    </Link>
  );
};

export default SubscriptionCard;
